/* eslint-disable */
import { qs, qsa } from "../utils/dom";
import sendRequest from "../utils/sendRequest";
import { Swiper } from "swiper";

const Filtration = {
    init: function (smoothScroll) {
        initRetraitesSlider();
        initFiltration();

        function initRetraitesSlider() {
            const sliderEl = qs("[data-retraites-slider-js]");
            if (!sliderEl) return;

            const swiper = new Swiper(sliderEl, {
                slidesPerView: 1,
                allowTouchMove: false,
                speed: 400,
                autoHeight: true,
            });

            const tabs = qsa("[data-retraites-tab-index]");
            tabs.forEach((tab) => {
                tab.addEventListener("click", () => {
                    const index = parseInt(
                        tab.getAttribute("data-retraites-tab-index"),
                        10,
                    );

                    swiper.slideTo(index);
                    tabs.forEach((item) => item.classList.remove("is-active"));
                    tab.classList.add("is-active");
                });
            });
        }

        function initFiltration() {
            const section = qs("[data-news-grid-section-js]");
            const grid = qs("[data-news-grid-js]");

            if (!section || !grid) return;

            const postType = grid.getAttribute("data-post-type");
            const loadMoreEl = qs("[data-load-more-js]");
            const loader = '<div class="posts-loader"><div></div></div>';
            const taxFilters = qsa("[data-tax-filter]");

            const filtrationData = {
                section,
                grid,
                postType,
            };

            let isLoading = false;

            function getTargetPostId() {
                const params = new URLSearchParams(window.location.search);
                const queryId = params.get("target_post");
                const hashMatch = window.location.hash.match(/^#post-(\d+)$/);

                return queryId || (hashMatch ? hashMatch[1] : null);
            }

            async function loadNextPage() {
                const currentPage =
                    Number(grid.getAttribute("data-paged-js")) || 1;
                const maxPages =
                    Number(grid.getAttribute("data-max-num-pages-js")) || 1;

                if (isLoading || currentPage >= maxPages) {
                    return false;
                }

                const nextPage = currentPage + 1;
                isLoading = true;
                grid.setAttribute("data-paged-js", String(nextPage));

                filtrationData.paged = String(nextPage);
                filtrationData.postsPerPage = grid.getAttribute(
                    "data-posts-per-page-js",
                );

                try {
                    const response = await filterParams(filtrationData);
                    return Boolean(response);
                } catch (error) {
                    // Do not skip a page if the request failed.
                    grid.setAttribute("data-paged-js", String(currentPage));
                    return false;
                } finally {
                    isLoading = false;
                }
            }

            async function scrollToRequestedPost() {
                const postId = getTargetPostId();
                const queryPostId = new URLSearchParams(
                    window.location.search,
                ).get("target_post");

                if (!postId) return;

                let target = document.getElementById(`post-${postId}`);

                // The backend should return enough posts when targetPost is supplied.
                // This loop remains a fallback for older backend code.
                while (!target) {
                    const loaded = await loadNextPage();

                    if (!loaded) break;

                    target = document.getElementById(`post-${postId}`);
                }

                if (!target) return;

                requestAnimationFrame(() => {
                    if (smoothScroll && typeof smoothScroll.update === "function") {
                        smoothScroll.update();
                    }

                    requestAnimationFrame(() => {
                        if (smoothScroll && typeof smoothScroll.scrollTo === "function") {
                            smoothScroll.scrollTo(target, {
                                offset: -80,
                                duration: 800,
                                disableLerp: false,
                            });
                        } else {
                            target.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                            });
                        }
                    });
                });

                // Only a photo_gallery post opens the modal automatically.
                if (
                    queryPostId &&
                    target.dataset.postType === "photo_gallery"
                ) {
                    const trigger = target.querySelector(".gallery-modal-trigger");

                    if (trigger) {
                        setTimeout(() => trigger.click(), 850);
                    }
                }

                // The target is handled once. Do not make subsequent Load More
                // requests target-aware and do not reopen the modal on refresh.
                if (queryPostId) {
                    const cleanUrl = new URL(window.location.href);
                    cleanUrl.searchParams.delete("target_post");
                    window.history.replaceState(
                        null,
                        "",
                        `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`,
                    );
                }
            }

            if (loadMoreEl) {
                loadMoreEl.addEventListener("click", () => {
                    loadNextPage();
                });
            }

            taxFilters.forEach((taxFilter) => {
                const filterOptions = taxFilter.querySelectorAll(
                    "[data-filter-option]",
                );
                const filterTitleEl = taxFilter.querySelector("[data-filter-title]");
                const filterDefaultTitle = taxFilter.getAttribute(
                    "data-default-filter-title",
                );

                filterOptions.forEach((option) => {
                    option.addEventListener("click", () => {
                        if (!filterTitleEl) {
                            const isAlreadyActive = option.classList.contains("is-active");
                            filterOptions.forEach((item) => item.classList.remove("is-active"));

                            if (isAlreadyActive && !option.hasAttribute("data-reset-all")) {
                                taxFilter.setAttribute("data-tax-val", "");
                            } else {
                                option.classList.add("is-active");
                                taxFilter.setAttribute(
                                    "data-tax-val",
                                    option.getAttribute("data-tax-term-id") || "",
                                );
                            }
                        } else if (!option.hasAttribute("data-reset-all")) {
                            taxFilter.setAttribute(
                                "data-tax-val",
                                option.getAttribute("data-tax-term-id"),
                            );
                            filterTitleEl.innerHTML = option.innerHTML;
                        } else {
                            taxFilter.setAttribute("data-tax-val", "");
                            filterTitleEl.innerHTML = filterDefaultTitle;
                        }

                        grid.innerHTML = loader;
                        grid.setAttribute("data-paged-js", "1");
                        filterParams(filtrationData);
                    });
                });
            });

            scrollToRequestedPost();
        }

        function filterParams(filtrationData) {
            const grid = filtrationData.grid;

            filtrationData.postsPerPage = grid.getAttribute(
                "data-posts-per-page-js",
            );
            filtrationData.paged = grid.getAttribute("data-paged-js");

            const taxFilters = qsa("[data-tax-filter]");

            taxFilters.forEach((taxFilter, index) => {
                filtrationData[`tax_${index + 1}_name`] = taxFilter.getAttribute(
                    "data-tax-name",
                );
                filtrationData[`tax_${index + 1}_val`] = taxFilter.getAttribute(
                    "data-tax-val",
                );
            });

            return getPosts(filtrationData);
        }

        async function getPosts(filtrationData) {
            const section = filtrationData.section;
            const grid = filtrationData.grid;

            section.classList.add("loading");

            try {
                const formData = new FormData();
                formData.append("postsPerPage", filtrationData.postsPerPage);
                formData.append("paged", filtrationData.paged);
                formData.append("postType", filtrationData.postType);

                const targetPostId = new URLSearchParams(
                    window.location.search,
                ).get("target_post");

                if (targetPostId) {
                    formData.append("targetPost", targetPostId);
                }

                for (let i = 1; i <= 2; i += 1) {
                    const taxName = filtrationData[`tax_${i}_name`];
                    const taxVal = filtrationData[`tax_${i}_val`];

                    if (taxName && taxVal) {
                        formData.append(`tax${i}Name`, taxName);
                        formData.append(`tax${i}Val`, taxVal);
                    }
                }

                const { data } = await sendRequest({
                    method: "POST",
                    data: formData,
                    endpoint: "filtration",
                });
                const response = await data;

                const loaderEl = grid.querySelector(".posts-loader");
                if (loaderEl) loaderEl.remove();

                if (response.targetFound) {
                    // Target mode returns page 1 through the requested post. Replace
                    // the initial server-rendered page to avoid duplicate cards.
                    grid.innerHTML = response.html;
                    grid.setAttribute("data-paged-js", String(response.loadedPage));
                } else {
                    // Normal Load More mode only returns the next page.
                    grid.insertAdjacentHTML("beforeend", response.html);
                }

                if (response.allLoaded) {
                    section.classList.add("all-loaded");
                } else {
                    section.classList.remove("all-loaded");
                }

                if (response.nothingFound) {
                    section.classList.add("nothing-found");
                } else {
                    section.classList.remove("nothing-found");
                }

                return response;
            } catch (error) {
                console.error(error);
                throw error;
            } finally {
                section.classList.remove("loading");

                if (smoothScroll && typeof smoothScroll.update === "function") {
                    requestAnimationFrame(() => smoothScroll.update());
                }
            }
        }
    },
};

export default Filtration;
